import React from 'react'
import { Text } from '../Text'
import { IProps } from './index'
import { CTATheme } from 'marketing-site/src/library/utils'
import { Image } from 'marketing-site/src/library/elements/Image'
import { CTALink } from '../../elements/CTALink'
import { mq } from 'marketing-site/src/library/utils'
import { TestimonialLink as TestimonialLinkDefault } from './element'
import { NewBrandingHoc } from '../../utils/NewBrandingHoc'

export function TestimonialLinkLegacy({ text, link, image }: IProps) {
  return (
    <div className="testimonial-link">
      <div className="testimonial-link-image">
        <Image {...image} />
      </div>
      <div className="testimonial-link-body">
        <Text size="lg">{text}</Text>
        <div className="testimonial-link-cta">
          <CTALink url={link} text="Learn more" bgColor={CTATheme.BlackFill} />
        </div>
      </div>

      <style jsx>
        {`
          .testimonial-link {
            background: #f5f5f5;
            border-radius: 8px;
            padding: 30px;
            margin: 50px 0;
            display: grid;
            grid-template-columns: 1fr;
            grid-column-gap: 30px;
            grid-row-gap: 30px;
          }

          .testimonial-link-image {
            margin: 0 auto;
            max-width: 160px;
          }

          .testimonial-link-cta {
            margin-top: 30px;
            text-align: center;
          }

          @media (${mq.tablet}) {
            .testimonial-link {
              margin: 70px 0;
              padding: 45px;
              text-align: left;
              grid-template-columns: 160px 1fr;
            }

            .testimonial-link-cta {
              text-align: left;
            }
          }

          @media (${mq.desktopLg}) {
            .testimonial-link {
              grid-column-gap: 50px;
            }
          }
        `}
      </style>
    </div>
  )
}

export const TestimonialLink = NewBrandingHoc(TestimonialLinkLegacy, TestimonialLinkDefault)
